// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {CourseSchedulingDetailsFormModuleLayout} from 'app_components/modules/admin/courseScheduling/details/courseSchedulingDetailsForm'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import CourseSchedulingDetailsService from 'app_services/admin/courseScheduling/courseSchedulingDetailsService'
import ReactSelectService from 'app_services/components/reactSelectService'
import DurationFieldService from 'app_services/components/durationFieldService'
// @end

// @import types
import { ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
// @end

// @ADD Component types
interface ICourseSchedulingDetailsFormModuleProps {
  onHandleSubmit?: (data: any) => void
  editData?: any
  viewer: boolean
  courseScheduling: ICourseSchedulingListItem | null
  scheduling: string[]
}
interface ICourseSchedulingDetailsFormModuleState {
  processing: boolean
  customErrors: any
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class CourseSchedulingDetailsFormModule extends Component<ICourseSchedulingDetailsFormModuleProps, ICourseSchedulingDetailsFormModuleState> {

  private durationFieldService: DurationFieldService
  private reactSelectService: ReactSelectService
  private courseSchedulingDetailsService: CourseSchedulingDetailsService
  private screenNotifications: ScreenNotificationsUtil
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ICourseSchedulingDetailsFormModuleProps) {
    super(props)
    this.state = {
      processing: false,
      customErrors: null,
    }

    this.reactSelectService = new ReactSelectService()
    this.courseSchedulingDetailsService = new CourseSchedulingDetailsService()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
    this.durationFieldService = new DurationFieldService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  onSubmit = async (data: any) => {

    this.setState({customErrors: null, processing: true})

    let customErrors: any = {}
    if (data.duration) {
      data.duration = this.durationFieldService.getSecondsFromDuration(data.duration)
      if (data.duration === 0) {
        customErrors['duration_invalid'] = this.i18nUtil.getTranslate('modules.course_scheduling.duration_invalid')
      }
    }

    if (this.props.courseScheduling?.schedulingMode?.name !== 'Virtual') {
      if (!data.sessions || (data.sessions && data.sessions.length === 0)) {
        customErrors['number_of_sessions_invalid'] = this.i18nUtil.getTranslate('modules.course_scheduling.details.number_of_sessions_invalid')
      }

      if (data.number_of_sessions && data.sessions) {
        if (data.sessions.length !== parseInt(data.number_of_sessions)) {
          customErrors['number_of_sessions_invalid'] = this.i18nUtil.getTranslate('modules.course_scheduling.details.number_of_sessions_invalid')
        }
      }
    }

    // @INFO: Si existen campos con error retorno
    if (Object.keys(customErrors).length > 0) {
      this.setState({processing: false, customErrors})
      return false
    }

    if (data.teacher) data.teacher = this.reactSelectService.formatReactSelectResponse(data.teacher)
    if (!data.reprograming || (data.reprograming && data.reprograming === "")) data.reprograming = undefined

    // console.log('onSubmit-data', data)
    // this.setState({processing: false, customErrors: null})
    // return false;

    data['sendEmail'] = true

    const courseSchedulingDetailResponse = await this.courseSchedulingDetailsService.insertOrUpdate(
      data,
      (this.props.editData && this.props.editData._id) ? `update/${this.props.editData._id}` : 'create'
    )

    if (courseSchedulingDetailResponse) {
      let screen_notification_label = 'components.screen_notifications.add'
      if (this.props.editData && this.props.editData._id) {
        screen_notification_label = 'components.screen_notifications.update'
      }

      this.screenNotifications.fireToast(
        {
          message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
        },
        {
          position: 'bottom-right',
        }
      )

      if (this.props.onHandleSubmit) {
        this.props.onHandleSubmit(courseSchedulingDetailResponse)
      }
    }

    this.setState({ processing: false })
  }

  render() {
    return(
      <CourseSchedulingDetailsFormModuleLayout
        editData={this.props.editData}
        processing={this.state.processing}
        onHandleSubmit={this.onSubmit}
        customErrors={this.state.customErrors}
        viewer={this.props.viewer}
        courseScheduling={this.props.courseScheduling}
        scheduling={this.props.scheduling}
      />
    )
  }
}

export default connect(mapStatesToProps)(CourseSchedulingDetailsFormModule)
